import { templateThemeTokens } from './templateThemeTokens.js';
import { fontStacks } from '@/stitches/fonts.js';
import { createTheme } from '@/stitches/index.js';
import { merge } from 'lodash-es';

const mergedTokens = merge(templateThemeTokens, {
  colors: {
    defaultFont: '$brandBlack',
    pageBackground: '$white',
  },
  fonts: {
    body: fontStacks.cabinet.value,
    heading: fontStacks.cabinet.value,
  },
});

export const midday = createTheme({ ...mergedTokens });
